// extracted by mini-css-extract-plugin
module.exports = {"Menu":"zt_a bag_h","Menu__offsetParent":"zt_b bag_bj","Menu__trigger--shadowed":"zt_c"};